import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { CommentApi } from 'app/modules/dashboard/api/comment.api';
import {
  COMMENT_REPORT_REASONS,
  VIDEO_REPORT_REASONS,
  WORKOUT_REPORT_REASONS,
} from 'app/helpers/report.helper';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { VideoApi } from 'app/modules/dashboard/api/video.api';
import { Subscription } from 'rxjs';
import { WorkoutService } from 'app/services/workout.service';
import {
  ButtonComponent,
  DropdownComponent,
  DropdownOption,
} from '@kinomap-dev/ng-ui-lib';
import { ToasterService } from 'app/services/toaster.service';

@Component({
  selector: 'app-watch-report-modal',
  templateUrl: './watchReportModal.component.html',
  styleUrls: ['./watchReportModal.component.scss'],
  standalone: true,
  imports: [TranslateModule, DropdownComponent, ButtonComponent],
})
export class WatchReportModal implements OnInit, OnDestroy {
  @Input() id: number;
  @Input() videoReport: boolean = false;
  @Input() isReported: boolean = false;
  @Input() commentReport: boolean = false;
  @Input() workoutReport: boolean = false;
  @Input() commentBody: string;
  @Input() userId: number;
  @Input() trackSectionId: number;
  @Input() type: 'watch' | 'scenic' | 'coaching' | 'workout';

  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  commentReportReasons: DropdownOption<string>[] = [];
  currentReason: string;
  subcriptions: Subscription[] = [];

  constructor(
    private commentApi: CommentApi,
    private videoApi: VideoApi,
    private workoutService: WorkoutService,
    private toasterService: ToasterService,
    public readonly translate: TranslateService
  ) { }

  sendCommentReport() {
    this.isReported = true;
    this.subcriptions = [
      ...this.subcriptions,
      this.commentApi
        .reportComment(
          this.id,
          this.commentBody,
          this.translate.instant(this.currentReason),
          this.userId,
          this.trackSectionId
        )
        .subscribe(() => {
          this.toasterService.success(
            null,
            this.translate.instant('watch.report_modal.toast_success.video') +
            '\n' +
            this.translate.instant('watch.report_modal.toast_success.common')
          );
          this.closeReportModal();
        }),
    ];
  }

  sendWorkoutReport(): void {
    this.isReported = true;
    this.subcriptions = [
      ...this.subcriptions,
      this.workoutService
        .report(
          this.id,
          this.translate.instant(this.currentReason),
          this.userId
        )
        .subscribe(() => {
          this.toasterService.success(
            null,
            this.translate.instant('watch.report_modal.toast_success.video') +
            '\n' +
            this.translate.instant('watch.report_modal.toast_success.common')
          );
          this.closeReportModal();
        }),
    ];
  }

  sendVideoReport() {
    switch (this.type) {
      case 'watch':
      case 'scenic': {
        /**
         * REPORT IF IT WAS A WATCH SCENIC
         */
        this.isReported = true;
        this.subcriptions = [
          ...this.subcriptions,
          this.videoApi
            .reportWatchVideo(
              this.id,
              this.translate.instant(this.currentReason)
            )
            .subscribe(() => {
              this.toasterService.success(
                null,
                this.translate.instant(
                  'watch.report_modal.toast_success.video'
                ) +
                '\n' +
                this.translate.instant(
                  'watch.report_modal.toast_success.common'
                )
              );
              this.closeReportModal();
            }),
        ];

        break;
      }
      case 'coaching':
        /**
         * REPORT IF IT WAS A COACHING SCENIC
         */
        this.isReported = true;
        this.subcriptions = [
          ...this.subcriptions,
          this.videoApi
            .reportCoachingVideo(
              this.id,
              this.translate.instant(this.currentReason)
            )
            .subscribe(() => {
              this.toasterService.success(
                null,
                this.translate.instant(
                  'watch.report_modal.toast_success.video'
                ) +
                '\n' +
                this.translate.instant(
                  'watch.report_modal.toast_success.common'
                )
              );
              this.closeReportModal();
            }),
        ];

        break;
    }
  }

  closeReportModal() {
    this.cancel.emit();
  }

  ngOnInit(): void {
    if (!this.videoReport && !this.commentReport && !this.workoutReport) {
      console.error('CommentReport,VideoReport or workoutReport are not set.');
    } else if (this.videoReport && this.commentReport && this.workoutReport) {
      console.error(
        'commentReport, workoutReport and VideoReport are both set.'
      );
    } else {
      if (this.commentReport) {
        this.commentReportReasons = COMMENT_REPORT_REASONS.map((reason) => ({
          value: reason,
          label: this.translate.instant(reason),
        }));
      } else if (this.videoReport) {
        this.commentReportReasons = VIDEO_REPORT_REASONS.map((reason) => ({
          value: reason,
          label: this.translate.instant(reason),
        }));
      } else if (this.workoutReport) {
        this.commentReportReasons = WORKOUT_REPORT_REASONS.map((reason) => ({
          value: reason,
          label: this.translate.instant(reason),
        }));
      }
    }

    this.currentReason = this.commentReportReasons[0].value;
  }

  ngOnDestroy(): void {
    this.subcriptions.forEach((sub) => sub.unsubscribe());
  }
}
